const colors = {
  blue: '#1d7ff9',
  gray1: '#f5f5f5',
  gray2: '#f4f4f4',
  red: '#ff0000'
};

const theme = {
  colors
};

export default theme;
